import React from 'react';

/** A content state with a useful next step; never a silent blank panel. */
export function PanelState({ kind = 'empty', title, description, action, onAction }: {
  kind?: 'loading' | 'empty' | 'error';
  title: string;
  description: string;
  action?: string;
  onAction?: () => void;
}) {
  return <section className={`ui-panel-state ui-panel-state--${kind}`} role={kind === 'error' ? 'alert' : 'status'} aria-live="polite" aria-busy={kind === 'loading'}>
    <div className="ui-panel-state-mark" aria-hidden="true">{kind === 'loading' ? '…' : kind === 'error' ? '!' : '◇'}</div>
    <h2>{title}</h2>
    <p>{description}</p>
    {action && onAction && <button type="button" className="ui-button ui-button--primary" onClick={onAction}>{action}</button>}
  </section>;
}
